let BASE_URL = window.location.origin.includes("localhost")
  ? "http://local.store-wholesalehealthclub.com/"
  : window.location.origin + "/";

const CountryList = [
  {
    id: 41,
    short_name: "CA",
    country: "Canada",
  },
  {
    id: 239,
    short_name: "US",
    country: "United States",
  },
];

function getCountryIdByCode(country_code) {
  let SelectedCountry = CountryList.filter((item) => {
    if (item.short_name === country_code) {
      return true;
    }
  });
  return SelectedCountry.length
    ? SelectedCountry[0].id
    : "Country code not found!.";
}

function GetCardType(number) {
  // visa
  var re = new RegExp("^4");
  if (number.match(re) != null) return "visa";

  // Mastercard
  // Updated for Mastercard 2017 BINs expansion
  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      number,
    )
  )
    return "master";

  // AMEX
  re = new RegExp("^3[47]");
  if (number.match(re) != null) return "amex";

  // Discover
  re = new RegExp(
    "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)",
  );
  if (number.match(re) != null) return "discover";

  // Diners
  re = new RegExp("^36");
  if (number.match(re) != null) return "diners";

  // Diners - Carte Blanche
  re = new RegExp("^30[0-5]");
  if (number.match(re) != null) return "diners";

  // JCB
  re = new RegExp("^35(2[89]|[3-8][0-9])");
  if (number.match(re) != null) return "jcb";

  // Visa Electron
  re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
  if (number.match(re) != null) return "visa";

  return "visa";
}

const Config = () => {};

function openWindowPopup(slug) {
  let w = 550;
  let h = 450;
  var x = window.screen.width / 2 - w / 2;
  var y = window.screen.height / 2 - h / 2;
  window.open(
    "/" + slug,
    "_blank",
    "toolbar=no,scrollbars=no,resizable=no,width=" +
      w +
      ",height=" +
      h +
      " left=" +
      x +
      ",top=" +
      y,
  );
}

const DTCAlpha2 = [
  {
    id: 69,
    funnel_name: "DTCAlpha Checkout2",
    funnel_slug: "DTC-alpha2",
    template_id: 5,
    checkout_file_name: "DTCAlphaCheckout2",
    first_product_label: "BUY 3  BOTTLES",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 328,
    first_product_name: "Alpha Drive Rx 3 Bottles Pack",
    first_product_retail: "192",
    first_product_price: "115",
    first_product_save: "77",
    first_product_each: "38.33",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 329,
    second_product_name: "Alpha Drive Rx 2 Bottles Pack",
    second_product_retail: "143",
    second_product_price: "95",
    second_product_save: "48",
    second_product_each: "47.50",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 331,
    third_product_name: "Alpha Drive Rx 1 Bottle",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "170",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2025-05-02T08:16:58.000000Z",
    updated_at: "2025-05-02T08:16:58.000000Z",
  },
  {
    first_product_img: "image\/HHVhITPr09mAp7xo4qDAgpPPFpmu1ksEyxTYqLP2.png",
    second_product_img: "image\/rQzfT7DR3GjINdfAtSfnkalDGsDeHKY0ULy6Edcg.png",
    third_product_img: "image\/hvBVklYceaKNd0VfbvEo027Ukc3ap0MbtcnAzuAX.png",
  },
];
const brain_syn_checkout = [
  {
    id: 71,
    funnel_name: "Brain Syn Checkout",
    funnel_slug: "brain-syn-checkout",
    template_id: 1,
    checkout_file_name: "BrainSynCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 343,
    first_product_name: "Synapticxr 5 Bottles Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 344,
    second_product_name: "Synapticxr 3 Bottles Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 346,
    third_product_name: "Synapticxr 1 Bottle Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2025-05-28T12:21:31.000000Z",
    updated_at: "2025-05-28T12:21:31.000000Z",
  },
  {
    first_product_img: "image\/pBPktYODgrE1IfQiep11Hmrm8AWhNtrt5iyRm2IL.png",
    second_product_img: "image\/IxnVzf9vUFZFsdC0AJXyvtzvlVLSBzKrpbyNzJ5d.png",
    third_product_img: "image\/nQntUIblqxMwA6DnQ3iQUQ42KHq4qugy4Rzzlup6.png",
  },
];

const brain_tech_checkout = [
  {
    id: 72,
    funnel_name: "Brain Tech Checkout",
    funnel_slug: "brain-tech-checkout",
    template_id: 1,
    checkout_file_name: "BrainTechCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 347,
    first_product_name: "5 Months Neuro Tech Iq Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 348,
    second_product_name: "3 Months Neuro Tech Iq Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 350,
    third_product_name: "1 Month Neuro Tech Iq Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2025-05-28T12:21:31.000000Z",
    updated_at: "2025-05-28T12:21:31.000000Z",
  },
  {
    first_product_img: "image\/RKWhiGLDMgv92r2HPsTQ59qMf0CLV0MJe1A1OrpD.png",
    second_product_img: "image\/xI8MUrgZP5mps9cfc9gNNIn6XKQ91B333tJjATPK.png",
    third_product_img: "image\/OVeyZK0OTU5D6i6gZJV04FXLHhM4FVMaaGmGUZK2.png",
  },
];

const NootropicCheckoutData = [
  {
    id: 50,
    funnel_name: "Nootropic Checkout",
    funnel_slug: "checkout-b",
    template_id: 1,
    checkout_file_name: "NootropicCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 145,
    first_product_name: "5 Months Neuro Tech Iq Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 146,
    second_product_name: "3 Months Neuro Tech Iq Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 147,
    third_product_name: "1 Month Neuro Tech Iq Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2023-07-31T15:44:05.000000Z",
    updated_at: "2025-01-02T09:22:45.000000Z",
  },
  {
    first_product_img: "image\/wuO2TzhrM0OpA32SysN8Ta88ocfX2gigI8ME9wFp.png",
    second_product_img: "image\/Yh0YZtPBxRiHxFJqlfZBytUjOaad5kURobhqkxNT.png",
    third_product_img: "image\/EvZiB4EmNVhlhAGFqwQjQODhDTHUsvJ1nnMduANL.png",
  },
];

const Gethard1pCheckoutData = [
  {
    id: 57,
    funnel_name: "Gethard1p Checkout",
    funnel_slug: "gethard1p-checkout",
    template_id: 6,
    checkout_file_name: "Gethard1pCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 212,
    first_product_name: "Alpha Drive Rx 5 Bottles Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 213,
    second_product_name: "Alpha Drive Rx 3 Bottles Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 215,
    third_product_name: "Alpha Drive Rx 1 Bottle Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2024-05-20T19:12:57.000000Z",
    updated_at: "2024-05-20T19:12:57.000000Z",
  },
  {
    first_product_img: "image\/5od3ETqgEnvjP9uiwHQ2uvAxhfyr85ZLKcxk888t.png",
    second_product_img: "image\/MXjODy9k2lDkFQepYwqWd1Q2Yhc53RQn3hP8qEWv.png",
    third_product_img: "image\/Q9JkJl6ywUB5ZkhaZv3Nm0V2TIbF8Ren4uFtEQ6N.png",
  },
];

const Get1hardppCheckoutData = [
  {
    id: 61,
    funnel_name: "Get1hardpp Checkout",
    funnel_slug: "get1hardpp-checkout",
    template_id: 6,
    checkout_file_name: "Get1hardppCheckout",
    first_product_label: "BUY 3  BOTTLES",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 246,
    first_product_name: "Alpha Drive Rx 3 Bottles Pack",
    first_product_retail: "192",
    first_product_price: "115",
    first_product_save: "77",
    first_product_each: "38.33",
    second_product_label: "BUY 2 BOTTLES",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 247,
    second_product_name: "Alpha Drive Rx 2 Bottles Pack",
    second_product_retail: "143",
    second_product_price: "95",
    second_product_save: "48",
    second_product_each: "47.50",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 249,
    third_product_name: "Alpha Drive Rx 1 Bottle",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2024-09-10T08:01:20.000000Z",
    updated_at: "2024-09-10T08:01:20.000000Z",
  },
  {
    first_product_img: "image\/Js6syP4Hek5G0lTTCmXgN3zkdpNCTv1TO6gzYBkm.png",
    second_product_img: "image\/I3miVzxGVYpeGcWObnwSuDQKbxthB2MWHlVLOJ4l.png",
    third_product_img: "image\/QCnF5GkRFeL6iTf6buLkWMQOlm94qNZDYiPaO1Tv.png",
  },
];

const Brain20pCheckoutData = [
  {
    id: 60,
    funnel_name: "Brain20p Checkout",
    funnel_slug: "brain20p-checkout",
    template_id: 1,
    checkout_file_name: "Brain20pCheckout",
    first_product_label: "BUY 3  BOTTLES",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 238,
    first_product_name: "Synapticxr 3 Bottles Pack",
    first_product_retail: "192",
    first_product_price: "115",
    first_product_save: "77",
    first_product_each: "38.33",
    second_product_label: "BUY 2 BOTTLES",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 239,
    second_product_name: "Synapticxr 2 Bottles Pack",
    second_product_retail: "143",
    second_product_price: "95",
    second_product_save: "48",
    second_product_each: "47.50",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 241,
    third_product_name: "Synapticxr 1 Bottle Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2024-08-22T08:07:33.000000Z",
    updated_at: "2024-08-22T08:07:33.000000Z",
  },
  {
    first_product_img: "image\/WxDNvbjJXHuyU0TYSAqsr45wk02VzssryMmwKtCU.png",
    second_product_img: "image\/FjqOYdUXmfy91rhFoQXs9dv5tW3VPm0uv6aUvoea.png",
    third_product_img: "image\/HBT8PE6qRZTBJLKbNhsNoxO7fOdniYgDrzR1Mj65.png",
  },
];

const Brain10pCheckoutData = [
  {
    id: 51,
    funnel_name: "Brain10p Checkout",
    funnel_slug: "brain10p-checkout",
    template_id: 1,
    checkout_file_name: "Brain10pCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 161,
    first_product_name: "5 Months Neuro Tech Iq Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 162,
    second_product_name: "3 Months Neuro Tech Iq Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 164,
    third_product_name: "1 Month Neuro Tech Iq Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2023-08-10T14:39:46.000000Z",
    updated_at: "2025-01-02T09:04:49.000000Z",
  },
  {
    first_product_img: "image\/RKWhiGLDMgv92r2HPsTQ59qMf0CLV0MJe1A1OrpD.png",
    second_product_img: "image\/xI8MUrgZP5mps9cfc9gNNIn6XKQ91B333tJjATPK.png",
    third_product_img: "image\/OVeyZK0OTU5D6i6gZJV04FXLHhM4FVMaaGmGUZK2.png",
  },
];

const DTCAlphaCheckoutData = [
  {
    id: 66,
    funnel_name: "DTCAlpha Checkout",
    funnel_slug: "DTC-alpha",
    template_id: 5,
    checkout_file_name: "DTCAlphaCheckout",
    first_product_label: "BUY 3  BOTTLES",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 304,
    first_product_name: "Alpha Drive Rx 3 Bottles Pack",
    first_product_retail: "192",
    first_product_price: "115",
    first_product_save: "77",
    first_product_each: "38.33",
    second_product_label: "BUY 2 BOTTLES",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 305,
    second_product_name: "Alpha Drive Rx 2 Bottles Pack",
    second_product_retail: "143",
    second_product_price: "95",
    second_product_save: "48",
    second_product_each: "47.50",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 307,
    third_product_name: "Alpha Drive Rx 1 Bottle",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2025-01-28T15:34:00.000000Z",
    updated_at: "2025-01-28T15:34:00.000000Z",
  },
  {
    first_product_img: "image\/HHVhITPr09mAp7xo4qDAgpPPFpmu1ksEyxTYqLP2.png",
    second_product_img: "image\/rQzfT7DR3GjINdfAtSfnkalDGsDeHKY0ULy6Edcg.png",
    third_product_img: "image\/hvBVklYceaKNd0VfbvEo027Ukc3ap0MbtcnAzuAX.png",
  },
];

const DTCSynapticCheckoutData = [
  {
    id: 67,
    funnel_name: "DTCSynaptic Checkout",
    funnel_slug: "DTC-synaptic",
    template_id: 5,
    checkout_file_name: "DTCSynapticCheckout",
    first_product_label: "BUY 3  BOTTLES",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 312,
    first_product_name: "Synapticxr 3 Bottles Pack",
    first_product_retail: "192",
    first_product_price: "115",
    first_product_save: "77",
    first_product_each: "38.33",
    second_product_label: "BUY 2 BOTTLES",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 313,
    second_product_name: "Synapticxr 2 Bottles Pack",
    second_product_retail: "143",
    second_product_price: "95",
    second_product_save: "48",
    second_product_each: "47.50",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 315,
    third_product_name: "Synapticxr 1 Bottle Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2025-02-05T10:03:25.000000Z",
    updated_at: "2025-02-05T10:03:25.000000Z",
  },
  {
    first_product_img: "image\/N34zv3AVgp09y7WjFkfqbGns0eiDzfNvKKoJiJtY.png",
    second_product_img: "image\/KzMVnQaeigbLiWJZ2AaIfwSYLxsZjODdACX0228G.png",
    third_product_img: "image\/5CiYVZdI0Pcat7WyMQVq3Es324I7IFwmnfm3InV1.png",
  },
];

const DTCNeurotechCheckoutData = [
  {
    id: 68,
    funnel_name: "DTCNeurotech Checkout",
    funnel_slug: "DTC-neurotech",
    template_id: 5,
    checkout_file_name: "DTCNeurotechCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 320,
    first_product_name: "5 Month Neuro Tech Iq Pack",
    first_product_retail: "266",
    first_product_price: "149",
    first_product_save: "170",
    first_product_each: "33.66",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 321,
    second_product_name: "3 Month Neuro Tech Iq Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLES \u2013 GET 1 FREE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 323,
    third_product_name: "1 Month Neuro Tech Iq Pack",
    third_product_retail: "269",
    third_product_price: "69",
    third_product_save: "170",
    third_product_each: "33.66",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2025-02-18T13:13:56.000000Z",
    updated_at: "2025-02-20T11:01:01.000000Z",
  },
  {
    first_product_img: "image\/Njn6XLZdkGYycqK1Zh6QC5UaZJ7C1i4oqlDG4YxG.png",
    second_product_img: "image\/pM7CIdM3IwNGdZiy1kVPxkkEv8d9C5xYGWB0Wg4I.png",
    third_product_img: "image\/cBnf8xbORvvEC05G8UYLdN0fZoIa8j97tfRBVlcp.png",
  },
];
const AlphaCheckoutData = [
  {
    id: 63,
    funnel_name: "Alpha Checkout",
    funnel_slug: "alpha-checkout",
    template_id: 6,
    checkout_file_name: "AlphaCheckout",
    first_product_label: "BUY 3  BOTTLES",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 262,
    first_product_name: "Alpha Drive Rx 3 Bottles Pack",
    first_product_retail: "192",
    first_product_price: "115",
    first_product_save: "77",
    first_product_each: "38.33",
    second_product_label: "BUY 2 BOTTLES",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 263,
    second_product_name: "Alpha Drive Rx 2 Bottles Pack",
    second_product_retail: "143",
    second_product_price: "95",
    second_product_save: "48",
    second_product_each: "47.50",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 265,
    third_product_name: "Alpha Drive Rx 1 Bottle",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2024-10-16T10:39:22.000000Z",
    updated_at: "2024-10-16T10:39:22.000000Z",
  },
  {
    first_product_img: "image\/bIWgIJD70YDB4n8P0zJs0TdoanvzfsHOI8fra4cd.png",
    second_product_img: "image\/IHcoJSl4LYry8YTnETNoPMv6Sy8Kv6j8SL9igeMe.png",
    third_product_img: "image\/7okCdeyWPyKFtLx5T71BAqpINOmZO5iGM2WNalu9.png",
  },
];

const SynapticCheckoutData = [
  {
    id: 62,
    funnel_name: "Synaptic Checkout",
    funnel_slug: "synaptic-checkout",
    template_id: 1,
    checkout_file_name: "SynapticCheckout",
    first_product_label: "BUY 3  BOTTLES",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 254,
    first_product_name: "Synapticxr 3 Bottles Pack",
    first_product_retail: "192",
    first_product_price: "115",
    first_product_save: "77",
    first_product_each: "38.33",
    second_product_label: "BUY 2 BOTTLES",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 255,
    second_product_name: "Synapticxr 2 Bottles Pack",
    second_product_retail: "143",
    second_product_price: "95",
    second_product_save: "48",
    second_product_each: "47.50",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 257,
    third_product_name: "Synapticxr 1 Bottle Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2024-09-23T13:44:59.000000Z",
    updated_at: "2024-09-23T13:44:59.000000Z",
  },
  {
    first_product_img: "image\/sNTPhjsX0xeKp6io54h85w88IH5LBLgXIOrDIuTL.png",
    second_product_img: "image\/vuYMD3WvaknEpbsbuwvHtlHzv3b7Zwan7c6e7XmD.png",
    third_product_img: "image\/AmgjWAdEEHc04TjAZStlGpKIXz3usRLfScqPCNCD.png",
  },
];

const Nootropic2pCheckoutData = [
  {
    id: 53,
    funnel_name: "Nootropic2p Checkout",
    funnel_slug: "nootropic2p-checkout",
    template_id: 1,
    checkout_file_name: "Nootropic2pCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 178,
    first_product_name: "5 Months Neuro Tech Iq Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 179,
    second_product_name: "3 Months Neuro Tech Iq Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 181,
    third_product_name: "1 Month Neuro Tech Iq Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2023-08-29T13:44:40.000000Z",
    updated_at: "2025-02-12T06:21:41.000000Z",
  },
  {
    first_product_img: "image\/X1UxMx9TjzJJkZdZ4zz0LChKCUiPuL3ng3Qk8WGk.png",
    second_product_img: "image\/TbqMWOhxXxq93feh3OyenVGT05xQnAaWhIYjlT8V.png",
    third_product_img: "image\/ZgU8uXKSwjBkIbYt89z4PmfW7Bc5tRHcvBtymkBC.png",
  },
];

const brain_tech_2_checkout = [
  {
    id: 73,
    funnel_name: "Brain Tech 2 Checkout",
    funnel_slug: "brain-tech-2-checkout",
    template_id: 1,
    checkout_file_name: "BrainTech2Checkout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 361,
    first_product_name: "5 Months Neuro Tech Iq Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 362,
    second_product_name: "3 Months Neuro Tech Iq Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 364,
    third_product_name: "1 Month Neuro Tech Iq Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2025-07-09T12:21:31.000000Z",
    updated_at: "2025-07-09T12:21:31.000000Z",
  },
  {
    first_product_img: "image\/RKWhiGLDMgv92r2HPsTQ59qMf0CLV0MJe1A1OrpD.png",
    second_product_img: "image\/xI8MUrgZP5mps9cfc9gNNIn6XKQ91B333tJjATPK.png",
    third_product_img: "image\/OVeyZK0OTU5D6i6gZJV04FXLHhM4FVMaaGmGUZK2.png",
  },
];

const Skincare2pCheckoutData = [
  {
    id: 52,
    funnel_name: "Skincare2p Checkout",
    funnel_slug: "cream2p-checkout",
    template_id: 3,
    checkout_file_name: "Cream2pCheckout",
    first_product_label: "BUY 3  BOTTLES – GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 169,
    first_product_name: "Blue Forrest Anti Aging Cream 5 Bottles Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES – GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 170,
    second_product_name: "Blue Forrest Anti Aging Cream 3 Bottles Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "Skincare Package 3",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 172,
    third_product_name: "Blue Forrest Anti Aging Cream 1 Bottle Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2023-08-10T14:44:34.000000Z",
    updated_at: "2023-08-10T14:44:34.000000Z",
  },
  {
    first_product_img: "image/826W0zxVKCKgJDWwkDyQ1jFWS5ftVhPGSGX0PpKL.png",
    second_product_img: "image/iLJ7KbTmXk9Z8zfnze1hspUlMuwoi6mPyprB7JPz.png",
    third_product_img: "image/6eAzifkWbufx1Q4gdkPiCYMlBX1QLNnpM2abCLSn.png",
  },
];

const acvgummiesCheckoutData = [
  {
    id: 45,
    funnel_name: "Gummies Funnel Checkout",
    funnel_slug: "checkout-acv",
    template_id: 2,
    checkout_file_name: "AcvCheckoutOne",
    first_product_label: "BUY 3 GET 2 FREE*",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 79,
    first_product_name: "Tru Body Acv Keto Gummies 5 Bottles",
    first_product_retail: "345",
    first_product_price: "195.00",
    first_product_save: "150",
    first_product_each: "39.00",
    second_product_label: "BUY 2 GET 1 FREE*",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 80,
    second_product_name: "Tru Body Acv Keto Gummies 3 Bottles",
    second_product_retail: "207",
    second_product_price: "147.00",
    second_product_save: "60",
    second_product_each: "49.00",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 81,
    third_product_name: "Tru Body Acv Keto Gummies 1 Bottle",
    third_product_retail: "69",
    third_product_price: "69.00",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2022-12-15T15:01:57.000000Z",
    updated_at: "2023-01-20T23:59:25.000000Z",
  },
  {
    first_product_img: "image/xLi6oWsadFa89uNHzgVpiyGrXqv5yWBUFxJcfTVB.png",
    second_product_img: "image/BcHE88i3qFBU9a2UC9hcPTnWR2wRpYIYpmYKiu0x.png",
    third_product_img: "image/BgghPGdJMrl5DOkQfdUosmmTKL1QXSgVVQ420w9x.png",
  },
];

const Extrahard1pCheckoutData = [
  {
    id: 74,
    funnel_name: "Extrahard1p Checkout",
    funnel_slug: "extrahard1p-checkout",
    template_id: 6,
    checkout_file_name: "Extrahard1pCheckout",
    first_product_label: "BUY 3  BOTTLES \u2013 GET 2 FREE",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 369,
    first_product_name: "Alpha Drive Rx 5 Bottles Pack",
    first_product_retail: "449",
    first_product_price: "149",
    first_product_save: "300",
    first_product_each: "29.60",
    second_product_label: "BUY 2 BOTTLES \u2013 GET 1 FREE",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 370,
    second_product_name: "Alpha Drive Rx 3 Bottles Pack",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "BUY 1 BOTTLE",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 372,
    third_product_name: "Alpha Drive Rx 1 Bottle Pack",
    third_product_retail: "69",
    third_product_price: "69",
    third_product_save: "0.00",
    third_product_each: "69.00",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2026-04-16T08:56:49.000000Z",
    updated_at: "2026-04-16T08:56:49.000000Z",
  },
  {
    first_product_img: "image\/5od3ETqgEnvjP9uiwHQ2uvAxhfyr85ZLKcxk888t.png",
    second_product_img: "image\/MXjODy9k2lDkFQepYwqWd1Q2Yhc53RQn3hP8qEWv.png",
    third_product_img: "image\/Q9JkJl6ywUB5ZkhaZv3Nm0V2TIbF8Ren4uFtEQ6N.png",
  },
];

const DermaPGXCheckoutData = [
  {
    id: 75,
    funnel_name: "Derma PGX  Checkout",
    funnel_slug: "dermapgx-checkout",
    template_id: 4,
    checkout_file_name: "DermaPGXCheckout",
    first_product_label: "Buy 5 Bottles Pack",
    first_product_shipping_id: "Free Shipping!",
    first_product_id: 380,
    first_product_name: "Derma Pgx Anti Wrinkle Cream 5 Bottle",
    first_product_retail: "266",
    first_product_price: "149",
    first_product_save: "170",
    first_product_each: "33.66",
    second_product_label: "Buy 3 Bottles Pack",
    second_product_shipping_id: "Free Shipping!",
    second_product_id: 379,
    second_product_name: "Derma Pgx Anti Wrinkle Cream 3 Bottle",
    second_product_retail: "269",
    second_product_price: "99",
    second_product_save: "170",
    second_product_each: "33.66",
    third_product_label: "Buy 1 Bottle Pack",
    third_product_shipping_id: "Free Shipping!",
    third_product_id: 378,
    third_product_name: "Derma Pgx Anti Wrinkle Cream 1 Bottle",
    third_product_retail: "269",
    third_product_price: "69",
    third_product_save: "170",
    third_product_each: "33.66",
    membership_add_on: 1,
    soft_delete: 0,
    created_at: "2026-04-28T07:24:04.000000Z",
    updated_at: "2026-04-28T07:24:04.000000Z",
  },
  {
    first_product_img: "image\/wJvxz6zHk3uv3vi4HsmPkYtow2NW1ROx5usoPSjF.webp",
    second_product_img: "image\/5wsbvYjHnaZ7mbRVkNd5pYgD5Srcltr0NbI2qoVo.webp",
    third_product_img: "image\/qMY1298IjoWoUYnSbS7t9zgEcyelmPQYFHiTFANH.webp",
  },
];

export {
  brain_tech_2_checkout,
  Nootropic2pCheckoutData,
  SynapticCheckoutData,
  AlphaCheckoutData,
  DTCNeurotechCheckoutData,
  DTCSynapticCheckoutData,
  DTCAlphaCheckoutData,
  DTCAlpha2,
  brain_syn_checkout,
  brain_tech_checkout,
  NootropicCheckoutData,
  Gethard1pCheckoutData,
  Get1hardppCheckoutData,
  Brain20pCheckoutData,
  Brain10pCheckoutData,
  BASE_URL,
  GetCardType,
  CountryList,
  getCountryIdByCode,
  openWindowPopup,
  Skincare2pCheckoutData,
  acvgummiesCheckoutData,
  Extrahard1pCheckoutData,
  DermaPGXCheckoutData,
};
